<div class="positions-overlay">
  <div class="positions-overlay-container">
    @if (!!finalIncumbentPositions?.length) {
      <div class="title">
        <p>{{ 'mercer-support.dialog.set-as-final-incumbent' | translate }}</p>
      </div>
    }
    <div>
      @for (pos of finalIncumbentPositions; track pos) {
        <div class="item">
          <p class="item-title">{{ pos.positionTitle }}</p>
          <p class="item-org">{{ pos.orgCode }}</p>
        </div>
      }
    </div>
    @if (!!shortlistedOnOpenPositions?.length) {
      <div class="title">
        <p>{{ 'mercer-support.dialog.shortlisted-on-open-positions' | translate }}</p>
      </div>
    }
    <div>
      @for (pos of shortlistedOnOpenPositions; track pos) {
        <div class="item shortlisted">
          <p class="item-title">{{ pos.positionTitle }}</p>
          <p class="item-org">{{ pos.orgCode }}</p>
        </div>
      }
    </div>
    @if (!!shortlistedOnClosedPositions?.length) {
      <div class="title">
        <p>{{ 'mercer-support.dialog.shortlisted-on-closed-positions' | translate }}</p>
      </div>
    }
    <div>
      @for (pos of shortlistedOnClosedPositions; track pos) {
        <div class="item shortlisted">
          <p class="item-title">{{ pos.positionTitle }}</p>
          <p class="item-org">{{ pos.orgCode }}</p>
        </div>
      }
    </div>
  </div>
</div>
